import {store} from '../main';
import {registerExternalPayloadSideEffects} from './externalPayload';

export function registerSideEffects(rootStore: typeof store) {
  registerExternalPayloadSideEffects(rootStore);
}
